/* =========================================================
   Zero Proof Enhancements (Theme-safe JS injectors)
   - Cart free-shipping progress (drawer + cart page)
   - Predictive search "Popular searches"
   ========================================================= */

(function () {
  // === CONFIG ===
  const FREE_SHIP_THRESHOLD_CENTS = 7500; // $75.00

  // Edit these to match your best sellers / categories
  const POPULAR_SEARCHES = [
    { label: "NA Wine", q: "non alcoholic wine" },
    { label: "NA Beer", q: "non alcoholic beer" },
    { label: "NA Spirits", q: "non alcoholic spirits" },
    { label: "Tequila", q: "tequila" },
    { label: "Gin", q: "gin" },
    { label: "Functional", q: "functional" }
  ];

  // --- Helpers ---
  const moneyFromCents = (cents) => {
    try {
      const currency =
        (window.Shopify && Shopify.currency && Shopify.currency.active) || "USD";
      return (cents / 100).toLocaleString(undefined, {
        style: "currency",
        currency
      });
    } catch {
      return `$${(cents / 100).toFixed(2)}`;
    }
  };

  const clamp = (n, min, max) => Math.min(max, Math.max(min, n));

  async function fetchCart() {
    const res = await fetch("/cart.js", { credentials: "same-origin" });
    if (!res.ok) throw new Error("Failed to fetch cart.js");
    return res.json();
  }

  // --- CART FREE SHIPPING BAR ---
  function buildFreeShipEl(subtotalCents) {
    const remaining = FREE_SHIP_THRESHOLD_CENTS - subtotalCents;
    const pct = clamp((subtotalCents / FREE_SHIP_THRESHOLD_CENTS) * 100, 0, 100);

    const wrap = document.createElement("div");
    wrap.className = "zp-free-ship" + (remaining <= 0 ? " zp-free-ship--hit" : "");

    const msg =
      remaining > 0
        ? `Add <strong>${moneyFromCents(remaining)}</strong> to get free shipping`
        : `Congrats! Your order ships <strong>free</strong>`;

    wrap.innerHTML = `
      <div class="zp-free-ship__msg">${msg}</div>
      <div class="zp-bar" aria-hidden="true"><span style="width:${pct}%"></span></div>
    `;

    return wrap;
  }

  function findCartTargets() {
    // Drawer container variations (Taste/Dawn-style)
    const drawer =
      document.querySelector("cart-drawer") ||
      document.querySelector("#CartDrawer") ||
      document.querySelector(".drawer") ||
      document.querySelector(".cart-drawer");

    const drawerBody =
      drawer?.querySelector(".drawer__inner") ||
      drawer?.querySelector(".drawer__inner-empty") ||
      drawer?.querySelector(".drawer__content") ||
      drawer;

    // Cart page container variations
    const cartForm =
      document.querySelector("form[action^='/cart']") ||
      document.querySelector("cart-items") ||
      document.querySelector(".cart") ||
      document.querySelector("main");

    return { drawerBody, cartForm };
  }

  function mountFreeShipBar(container, subtotalCents) {
    if (!container) return;

    // Don't duplicate
    const existing = container.querySelector(".zp-free-ship");
    const bar = buildFreeShipEl(subtotalCents);

    // Insert near top of container
    if (existing) existing.replaceWith(bar);
    else container.prepend(bar);
  }

  async function refreshFreeShip() {
    try {
      const cart = await fetchCart();
      const subtotalCents = cart.items_subtotal_price ?? cart.total_price ?? 0;

      const { drawerBody, cartForm } = findCartTargets();

      // Drawer bar
      mountFreeShipBar(drawerBody, subtotalCents);

      // Cart page bar
      mountFreeShipBar(cartForm, subtotalCents);
    } catch {
      // silent fail keeps theme safe
    }
  }

  // --- PREDICTIVE SEARCH POPULAR SEARCHES ---
  function buildPopularSearchesEl() {
    const wrap = document.createElement("div");
    wrap.className = "zp-popular-searches";
    wrap.innerHTML = `
      <div class="zp-popular-searches__title">Popular searches</div>
      <div class="zp-chip-row">
        ${POPULAR_SEARCHES.map((item) => {
          const url = `/search?q=${encodeURIComponent(item.q)}&type=product`;
          return `<a class="zp-chip" href="${url}">${item.label}</a>`;
        }).join("")}
      </div>
    `;
    return wrap;
  }

  function mountPopularSearches() {
    // Predictive search container variations
    const predictive =
      document.querySelector("predictive-search") ||
      document.querySelector(".predictive-search") ||
      document.querySelector("#predictive-search-results") ||
      document.querySelector("[data-predictive-search]");

    if (!predictive) return;

    const host =
      predictive.querySelector(".predictive-search__results") ||
      predictive.querySelector(".predictive-search") ||
      predictive;

    if (!host) return;

    if (host.querySelector(".zp-popular-searches")) return;
    host.appendChild(buildPopularSearchesEl());
  }

  // --- Observers / hooks ---
  function hookCartChanges() {
    // Theme events (not always present, but harmless)
    document.addEventListener("cart:refresh", refreshFreeShip);
    document.addEventListener("cart:updated", refreshFreeShip);

    // Watch DOM changes; cart drawer rerenders often
    const mo = new MutationObserver(() => refreshFreeShip());
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }

  function hookPredictiveSearch() {
    const handler = () => mountPopularSearches();
    document.addEventListener("keyup", handler, { passive: true });
    document.addEventListener("click", handler, { passive: true });
    setTimeout(mountPopularSearches, 800);
  }

  // Init
  refreshFreeShip();
  hookCartChanges();
  hookPredictiveSearch();
})();
